import React from "react";
import PageHeader from "@/components/PageHeader";
import Blog from "@/components/Blog";
import CtaBanner from "@/components/CtaBanner";
import { useLayout } from "@/components/Layout";

export default function BlogsPage() {
  const { openPlan } = useLayout();
  return (
    <div data-testid="blogs-page">
      <PageHeader
        overline="From the Journal"
        title={"Notes from our\nconcierge desk."}
        subtitle="Guides, city breakdowns, seasonal windows and quiet luxuries — written by the same consultants who plan your journeys."
        image="https://images.unsplash.com/photo-1488646953014-85cb44e25828?q=80&w=2000&auto=format&fit=crop"
      />
      <Blog />
      <CtaBanner onPlanTrip={() => openPlan()} />
    </div>
  );
}
